import { Page } from '@optools/components/layout/page';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/media-validation')({
  beforeLoad: authorizedRouteLoader('mediaValidation'),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page
      links={[
        { label: 'Litmus', to: '/media-validation/litmus' },
        { label: 'Player Validator', to: '/media-validation/player-validator' },
      ]}
      title="Media Validation"
    />
  );
}
